/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Box } from "@mui/material";
import { LightTooltip, StyledInfoIcon } from "../../../components/statistics_cards/styles";
import { ComparisonRow, EMPTY_DISPLAY } from "./cells";
import { ALLOCATED_METRIC, METRIC_DESCRIPTIONS } from "./metric_copy";
import {
  allocatedMetricCardStyles,
  metricCardStyles,
  metricGridStyles,
  metricLabelStyles,
  metricValueStyles,
  panelHeadingStyles,
} from "./styles";

/**
 * The metric rail for one grain — a restaurant or a single revenue center. Renders
 * whatever rows the API sends rather than a hardcoded list, so a metric added server
 * side appears without a frontend change.
 */
export const DailyLogbookMetricPanel = ({ title, metrics = [], testIdPrefix }) => (
  <Box data-testid={`${testIdPrefix}-metrics`}>
    <Box sx={panelHeadingStyles}>{title}</Box>
    {metrics.length === 0 ? (
      <Box sx={{ fontSize: "13px", color: "#71717a", marginBottom: "20px" }}>
        No metrics for this day.
      </Box>
    ) : (
      <Box sx={metricGridStyles} data-testid={`${testIdPrefix}-metrics-grid`}>
        {metrics.map((metric) => {
          const isAllocated = metric.metric === ALLOCATED_METRIC;
          const tooltip = METRIC_DESCRIPTIONS[metric.metric];

          return (
            <Box
              key={metric.metric}
              data-testid={`${testIdPrefix}-metric-${metric.metric}`}
              data-allocated={isAllocated ? "true" : undefined}
              sx={isAllocated ? allocatedMetricCardStyles : metricCardStyles}
            >
              <Box sx={metricLabelStyles}>
                <span>{metric.label}</span>
                {tooltip ? (
                  <LightTooltip title={tooltip} placement="top">
                    <StyledInfoIcon />
                  </LightTooltip>
                ) : null}
              </Box>
              <Box
                sx={metricValueStyles}
                data-testid={`${testIdPrefix}-value-${metric.metric}`}
              >
                {metric?.today?.display ?? EMPTY_DISPLAY}
              </Box>
              <ComparisonRow
                label="SDLW"
                cell={metric.sdlw}
                varianceCell={metric.var_sdlw}
                testId={`${testIdPrefix}-sdlw-${metric.metric}`}
              />
              <ComparisonRow
                label="SDLY"
                cell={metric.sdly}
                varianceCell={metric.var_sdly}
                testId={`${testIdPrefix}-sdly-${metric.metric}`}
              />
            </Box>
          );
        })}
      </Box>
    )}
  </Box>
);
